/**
 * 打开新视图
 * 目前适用于卡牛，随手记
 */
import useragent from '@common/useragent'
import { call, uriSuishouji } from './bridge'

const enablePullRefresh = (opts) => {
  if (useragent.isSuishouji) {
    call(uriSuishouji('enablePullRefresh', opts))
  }
}

export default enablePullRefresh

export const pullRefresh = (enable) => {
  enablePullRefresh({
    enable // 是否开启
  })
}